import { defineMessage } from 'services/localization';

export const messages = {
    addAutoApprovalRule: defineMessage('add_autoapproval_rule'),
    addApprover: defineMessage('add_an_approver'),
    addReviewer: defineMessage('add_a_reviewer'),
    addRequester: defineMessage('add_a_requester'),
};
